import { BarChart3, Bus, FileText, ShieldCheck, Users } from 'lucide-react';

import logoCidade from '@/ui/assets/logo-cidade-sp-branco.png';
import { TegLogo } from '@/ui/TegLogo';

/**
 * Painel institucional das telas de autenticacao.
 *
 * A superficie usa os tokens da barra lateral (`bg-sidebar`,
 * `text-sidebar-foreground`), que sao os do azul institucional Pantone 654 C e
 * ja passam pela auditoria de contraste nos dois temas
 * (apps/web/scripts/auditar-contraste.ts). Nenhuma cor fixa: o azul nao entra
 * como `bg-[#173...]` (docs/DESIGN-SYSTEM.md, secao 2).
 *
 * A lista de recursos e ESTATICA de proposito. Carrossel que troca sozinho
 * exigiria botao de pausa para cumprir a WCAG 2.1 (critério 2.2.2), e conteudo
 * que se mexe atras de um formulario de entrada nao ajuda ninguem a entrar.
 *
 * Escondido abaixo de `lg`: em 375 px o que importa e o formulario.
 */

const RECURSOS = [
  {
    icone: Bus,
    titulo: 'Frota e condutores',
    texto: 'Veículos, condutores e monitores num só lugar.',
  },
  {
    icone: FileText,
    titulo: 'Termos e ordens de serviço',
    texto: 'Credenciamento e operação sem papel.',
  },
  {
    icone: BarChart3,
    titulo: 'Apuração e remuneração',
    texto: 'Medição mensal, demonstrativo e empenho.',
  },
  {
    icone: ShieldCheck,
    titulo: 'Fiscalização',
    texto: 'Ocorrências, penalidades e recursos com trilha.',
  },
  {
    icone: Users,
    titulo: 'Portal do transportador',
    texto: 'Acompanhamento pela própria empresa.',
  },
];

export function PainelInstitucional() {
  return (
    <aside
      className="hidden lg:flex lg:w-1/2 flex-col justify-between gap-10 bg-sidebar p-10 text-sidebar-foreground xl:p-14"
      aria-label="Sobre o Sistema TEG"
    >
      <img src={logoCidade} alt="Prefeitura de São Paulo" className="h-16 w-auto self-start" />

      <div className="max-w-104 space-y-8">
        <div className="space-y-3">
          <h2 className="flex items-center gap-4 text-3xl font-extrabold leading-tight xl:text-4xl xl:leading-10">
            <TegLogo className="h-16 w-16 rounded-2xl bg-sidebar-accent [&>img]:h-10 [&>img]:w-10" />
            <span>
              Transporte Escolar
              <br />
              Gratuito
            </span>
          </h2>
          <p className="text-sm leading-relaxed text-sidebar-foreground/80">
            Plataforma de gestão do transporte escolar gratuito do município de São Paulo.
          </p>
        </div>

        <ul className="space-y-4">
          {RECURSOS.map(({ icone: Icone, titulo, texto }) => (
            <li key={titulo} className="flex items-start gap-3">
              <span className="mt-0.5 rounded-lg bg-sidebar-accent p-2 text-sidebar-accent-foreground">
                <Icone className="h-4 w-4" aria-hidden="true" />
              </span>
              <span>
                <span className="block text-sm font-semibold">{titulo}</span>
                <span className="block text-xs leading-relaxed text-sidebar-foreground/75">
                  {texto}
                </span>
              </span>
            </li>
          ))}
        </ul>
      </div>

      <p className="text-xs text-sidebar-foreground/60">
        DTP / SMT — Departamento de Transportes Públicos
      </p>
    </aside>
  );
}
